module.exports = __webpack_public_path__ + "static/media/sunny.588c79c2.jfif";